'use strict';

console.log("App 3"); //*Princy
define(['underscore', 'edge/quoteandbind/pa/config/RouteConfig', 'edge/quoteandbind/pa/directives/PAEditDriver', 'edge/quoteandbind/pa/directives/PAEditVehicle', 'edge/quoteandbind/pa/directives/PAConfirmation', 'edge/quoteandbind/pa/directives/PAEditCoverages', 'edge/quoteandbind/pa/directives/PAViewCoverages', 'edge/policyjob/services/VinLookupService', 'edge/quoteandbind/common/app', 'edge/policyjob/app', 'edge/platform/widgets/time/module', 'angularRouter'
// '../../../../../../app/customer/js/src/edge/quoteandbind/pa/assets/angularjs-crypto.js', //*Princy
// '../../../../../../app/customer/js/src/edge/quoteandbind/pa/assets/CryptoJSCipher.js' //*Princy
], function (_, RouteConfig, EditDriver, EditVehicle, PAConfirmation, PAEditCoverages, PAViewCoverages) {
    return angular.module('edge.quoteandbind.pa.app', ['edge.quoteandbind.common.app', 'edge.policyjob.app', 'edge.platform.widgets.ui.time']) //*Princy added angularjs-crypto

    .config(['$stateProvider', 'state_plugin_config', function ($stateProvider, RootStateConfig) {
        var states = new RouteConfig(RootStateConfig);
        for (var stateName in states) {
            if (states.hasOwnProperty(stateName)) {
                $stateProvider.state(stateName, states[stateName]);
            }
        }
    }]).filter('orderObjectBy', function () {
        return function (items, field, reverse) {
            var filtered = [];
            angular.forEach(items, function (item) {
                filtered.push(item);
            });
            filtered.sort(function (a, b) {
                /*eslint-disable */
                return a[field] > b[field] ? 1 : a[field] < b[field] ? -1 : 0;
                /*eslint-enable */
            });
            if (reverse) {
                filtered.reverse();
            }
            return filtered;
        };
    }).directive('gwQnbPaEditDriver', EditDriver).directive('gwQnbPaEditVehicle', EditVehicle).directive('gwPaConfirmation', PAConfirmation).directive('gwQnbPaEditCoverages', PAEditCoverages).directive('gwQnbPaViewCoverages', PAViewCoverages).constant('VinLookupEnabled', true).value('pa.qnb.editableDriverDOB', false);
});


/*****************
 ** WEBPACK FOOTER
 ** ./common/grunt/webpack/loaders/conditional?if=quoteandbind_lob&equals=pa!./common/js/src/edge/quoteandbind/pa/app.js
 ** module id = 352
 ** module chunks = 0
 **/